if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        // this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        this.elements.viewer.querySelector('ul').addEventListener('scroll', this.setActiveAfterSrcoll.bind(this));
        // if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      //   onSlideChanged(event) {
      //     const thumbnail = this.elements.thumbnails.querySelector(
      //       `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //     );
      //     this.setActiveThumbnail(thumbnail);
      //   }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.elements.viewer.querySelector('ul').scrollTo({
          left: activeMedia.offsetLeft - this.elements.viewer.offsetLeft,
          behavior: 'smooth',
        });

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.classList.remove('tw-border', 'tw-block', 'tw-border-mauve');
          element.removeAttribute('aria-current');
        });
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        thumbnail.querySelector('button').classList.add('tw-border', 'tw-block', 'tw-border-mauve');
        // if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        // this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      setActiveAfterSrcoll(e) {
        var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
        var timeOut = atSnappingPoint ? 0 : 150; //see notes

        clearTimeout(e.target.scrollTimeout); //clear previous timeout

        e.target.scrollTimeout = setTimeout(() => {
          //using the timeOut to evaluate scrolling state
          if (!timeOut) {
            const newSlide = Math.floor(e.target.scrollLeft / e.target.offsetWidth);
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-media-position="${newSlide}"]`);
            const mediaId = activeThumbnail.dataset.target;

            const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
              element.classList.remove('is-active');
            });
            activeMedia.classList.add('is-active');

            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
          // else {
          //   console.log('User stopped scrolling.');
          // }
        }, timeOut);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      //   playActiveMedia(activeItem) {
      //     window.pauseAllMedia();
      //     const deferredMedia = activeItem.querySelector('.deferred-media');
      //     if (deferredMedia) deferredMedia.loadContent(false);
      //   }

      // preventStickyHeader() {
      //   this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      //   if (!this.stickyHeader) return;
      //   this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      // }

      //   removeListSemantic() {
      //     if (!this.elements.viewer.slider) return;
      //     this.elements.viewer.slider.setAttribute('role', 'presentation');
      //     this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      //   }
    }
  );
}
